<template>
    <div>
        <div class="card">
            <div class="card-header main-card">
                Administración de zonas
            </div>
            <div class="card-body">
                <b-container>
                    <div class="mb-1">
                        <b-dropdown
                            size="lg"
                            variant="link"
                            toggle-class="text-decoration-none"
                            class="float-right"
                            no-caret
                        >
                            <template v-slot:button-content>
                                <i class="fa fa-ellipsis-v"></i>
                            </template>
                            <b-dropdown-item>
                                <div v-b-modal="'addSuprazone'">
                                    <i class="fa fa-plus-circle mr-2 fa-fw"/> Nueva
                                </div>
                                <admin-add-suprazone-modal />
                            </b-dropdown-item>
                        </b-dropdown>
                    </div>
                    <table class="table table-hover table-bordered table-sm mt-1">
                        <thead>
                            <tr>
                                <th scope="col">Id</th>
                                <th scope="col">Nombre</th>
                                <th scope="col">Configurar</th>
                            </tr>
                        </thead>
                        <tbody>
                            <admin-suprazones-table-row :item="suprazone" v-for="suprazone in suprazones" :key="suprazone.id" />
                        </tbody>
                    </table>
                </b-container>
            </div>
        </div>
    </div>
</template>


<script>
import AdminSuprazonesTableRow from './AdminSuprazonesTableRow'
import AdminAddSuprazoneModal from './AdminAddSuprazoneModal'
import { mapGetters } from 'vuex'

export default {
    components: {
        AdminSuprazonesTableRow,
        AdminAddSuprazoneModal,
    },
    async mounted() {
        await this.$store.dispatch("suprazones/loadSuprazones")
    },
    computed: {
        ...mapGetters(['suprazones'])
    }
}
</script>